import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BollettiniMeteoRoutingModule } from "./bollettini-meteo-routing.module";
import { BollettiniMeteoComponent } from "./bollettini-meteo.component";
import { NbCardModule, NbDatepickerModule } from "@nebular/theme";
import { AgGridModule } from "ag-grid-angular";
import { NgbDatepickerModule } from "@ng-bootstrap/ng-bootstrap";
import { FormsModule } from "@angular/forms";



@NgModule({
  declarations: [BollettiniMeteoComponent],
  imports: [
    CommonModule,
    BollettiniMeteoRoutingModule,
    NbCardModule,
    AgGridModule,
    NgbDatepickerModule,
    FormsModule
  ],
  exports:[BollettiniMeteoComponent]
})
export class  BollettiniMeteoModule { }
